import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';
import { send as sendAlert } from 'ha/modules/Alertbar/actions';
import reportError from 'ha/helpers/bugsnag/reportError';
import { defineKey as T } from 'ha/i18n';
import { GlobalState } from 'ha/types/store';

const ERROR_MESSAGE = T(
  'There was an error removing your favorite listing. Please try again later',
);

export const enum ActionTypes {
  START = '[favorites] REMOVE_FAVORITE',
  DONE = '[favorites] REMOVE_FAVORITE_DONE',
  FAIL = '[favorites] REMOVE_FAVORITE_FAIL',
}

export const Actions = {
  start: (listingId: number) => createAction(ActionTypes.START, listingId),
  done: (listingId: number) => createAction(ActionTypes.DONE, listingId),
  fail: (listingId: number) => createAction(ActionTypes.FAIL, listingId),
};
export type Actions = ActionsUnion<typeof Actions>;

type RemoveFavoriteListing = (listingId: number) => Thunk<GlobalState>;

const removeFavoriteListing: RemoveFavoriteListing = listingId => (
  dispatch,
  _,
  { apiV2 },
) => {
  dispatch(Actions.start(listingId));

  return apiV2
    .removeFavoriteListing(listingId)
    .then(() => {
      dispatch(Actions.done(listingId));
    })
    .catch(error => {
      reportError(error);
      dispatch(
        sendAlert({
          text: ERROR_MESSAGE,
          kind: 'danger',
          dismissAfter: 5000,
        }),
      );
      dispatch(Actions.fail(listingId));
    });
};

export default removeFavoriteListing;
